/**
 * API Configuration
 * Centralized configuration for API client
 */

/**
 * Get API base URL from environment or use default
 * @type {string}
 */
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://admin.jobscribe.in/api';

/**
 * Get login URL from environment or use default
 * URL to redirect to when user needs to log in (main JobScribe app)
 * @type {string}
 */
export const LOGIN_URL = import.meta.env.VITE_LOGIN_URL || 'https://jobscribe.in/login';

/**
 * Franchise/marketing API base (includes `/api` suffix).
 * Used for public leads (custom pricing). Falls back to admin API when unset.
 * @type {string}
 */
export const FRANCHISE_API_BASE_URL = (
  import.meta.env.VITE_FRANCHISE_API_BASE_URL || API_BASE_URL
).replace(/\/$/, '');

/**
 * Default request timeout in milliseconds
 * @type {number}
 */
export const REQUEST_TIMEOUT = 30000; // 30 seconds

/**
 * Storage keys for authentication
 * @type {Object<string, string>}
 */
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  REFRESH_TOKEN: 'refresh_token',
  USER_DATA: 'user_data',
};

/**
 * HTTP status codes
 * @type {Object<number, string>}
 */
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  UNPROCESSABLE_ENTITY: 422,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
};

/**
 * Default headers for all requests
 * @type {Object<string, string>}
 */
export const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
  'Accept': 'application/json',
};
